// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".1c43f2abebe0445a0fe481cc5bd511fb.js";
};